'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _EditorialArticleCard = require('./EditorialArticleCard');

var _EditorialArticleCard2 = _interopRequireDefault(_EditorialArticleCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EditorialArticleCard2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/EditorialArticleCard/index.js
// module id = 573
// module chunks = 11